import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import type { ConnectionRowPresentation } from './types'

interface ConnectionsCardsProps {
	connectionRows: ConnectionRowPresentation[]
	onSelectConnection: (row: ConnectionRowPresentation) => void
	selectedConnectionId?: string
}

export function ConnectionsCards({
	connectionRows,
	onSelectConnection,
	selectedConnectionId,
}: ConnectionsCardsProps) {
	return (
		<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
			{connectionRows.map((row) => (
				<Card
					key={row.id}
					className={`cursor-pointer hover:shadow-md transition-shadow ${
						selectedConnectionId === row.id ? 'ring-2 ring-primary' : ''
					}`}
					onClick={() => onSelectConnection(row)}
				>
					<CardHeader>
						<CardTitle className="flex items-center gap-3 truncate">
							{row.logoSrc ? (
								<img src={row.logoSrc} alt={`${row.platform} logo`} className="h-5 w-5" />
							) : (
								<div className="h-5 w-5 rounded bg-muted flex items-center justify-center text-xs font-medium">
									{row.platform.charAt(0).toUpperCase()}
								</div>
							)}
							{row.platform}
						</CardTitle>
					</CardHeader>
					<CardContent className="space-y-2">
						{row.description && <p className="text-sm text-muted-foreground">{row.description}</p>}
						<div className="flex items-center justify-between">
							<p className="text-xs text-muted-foreground capitalize">{row.owner}</p>
							<Badge variant={row.status === 'active' ? 'default' : 'secondary'} className="capitalize">
								{row.status}
							</Badge>
						</div>
					</CardContent>
				</Card>
			))}
		</div>
	)
}


